var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-4.37116e-07 10C-4.26953e-07 9.76754 0.089603 9.53481 0.268581 9.35731L9.4352 0.26642C9.79339 -0.0888067 10.3734 -0.0888067 10.7314 0.26642C11.0893 0.621647 11.0895 1.19687 10.7314 1.55187L2.21282 10L10.7314 18.4482C11.0895 18.8034 11.0895 19.3787 10.7314 19.7337C10.3732 20.0887 9.79316 20.0889 9.4352 19.7337L0.268581 10.6428C0.089603 10.4653 -4.47279e-07 10.2325 -4.37116e-07 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselArrowLeft);
export default __webpack_public_path__ + "static/media/carousel-arrow-left.09e903256dd4669fe7fddd5d21fec236.svg";
export { ForwardRef as ReactComponent };